const getDetectionFace = (detection) => detection.face ?? detection.faceId ?? detection.cameraFace ?? detection.side ?? detection.tags?.face ?? null;
const getDetectionPalletId = (detection) => detection.palletId ?? detection.pallet_id ?? detection.numeroPalet ?? null;
const getDetectionDefect = (detection) => detection.defect ?? detection.defectType ?? detection.defect_type;

const getGroupKey = (detection) => {
  const palletId = getDetectionPalletId(detection);
  const face = getDetectionFace(detection);
  const defect = getDetectionDefect(detection);
  const timestamp = Number(detection.timestamp);

  // Never merge detections when one of the requested grouping fields is missing.
  if (palletId === null || palletId === undefined || palletId === '' || face === null || face === undefined || face === '' || defect === null || defect === undefined || !Number.isFinite(timestamp)) return null;
  return JSON.stringify([String(palletId), String(face), Math.floor(timestamp), String(defect)]);
};

export const groupVeralliaDashboardDetections = (detections) => {
  const groups = new Map();

  detections.forEach((detection, index) => {
    const groupingKey = getGroupKey(detection);
    const key = groupingKey === null ? `single:${index}` : `group:${groupingKey}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(detection);
  });

  return [...groups.entries()].map(([key, members]) => {
    const photos = [...new Set(members.map((detection) => detection.image).filter((src) => typeof src === 'string' && src.length > 0))];
    const sizes = members.map((detection) => detection.size);
    const validSizes = sizes.filter(Number.isFinite);

    return {
      ...members[0],
      id: key,
      image: photos[0] ?? members[0].image,
      imageSources: photos,
      detectionCount: members.length,
      sizes,
      size: validSizes.length > 0 ? Math.max(...validSizes) : members[0].size,
    };
  });
};
